<div class="wrapper">
  <div class="line">
    <app-page-info
      [resourceName]="'План факт'"
      [loginAndRoles]="loginAndRoles"
    />
    <div class="year-selection">
      <mat-form-field appearance="outline">
        <mat-select
          [value]="selectedYear()"
          (selectionChange)="handleSelectChange($event)"
        >
          @for (year of years; track year) {
            <mat-option [value]="year">
              {{year}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="table">
    <div class="months">
      @for (monthData of dataGroupedByMonths(); track $index) {
        <div class="month">
          <div class="month-name">
            <span>{{ monthData.monthName }}</span>
            @if (!monthData.planFactData) {
              <button
                mat-stroked-button
                color="primary"
                [disabled]="isLoadingMonth()[monthData.monthNumber]"
                (click)="openMonthData(monthData.monthNumber)"
              >
                Открыть
              </button>
            }
            @if (monthData.planFactData) {
              <button
                mat-stroked-button
                color="accent"
                (click)="closeMonthData(monthData.monthNumber)"
              >
                Закрыть
              </button>
            }
            @if (isLoadingMonth()[monthData.monthNumber]) {
              <div class="month-name-loader">
                <app-loader/>
              </div>
            }
          </div>
          @if (monthData.planFactData) {
            <div
              class="products"
              @smoothShowHideHeight
            >
              @if (!monthData.planFactData.products.length) {
                <div>Нет данных за выбранный период</div>
              }
              @for (product of monthData.planFactData.products; track $index) {
                <div class="product">
                  <div class="groups">
                    <!--Product-->
                    <div class="group">
                      <div class="group-name-container">
                        <div class="group-name">
                          {{product.productName}}
                        </div>
                        <button
                          class="delete-button delete-product"
                          appDeleteFocus
                          (click)="handleDeleteProductButtonClick(product.id, monthData.monthNumber)"
                        >
                          <i class="delete-icon"></i>
                        </button>
                      </div>
                      <div class="group-headers">
                        <div class="column name">Имя</div>
                        <div class="column">План</div>
                        <div class="column">
                          <app-fact-header/>
                        </div>
                        <div class="column">Реализация</div>
                        @for (config of columnsConfig; track $index) {
                          @if (isAnyTeamInProduct(product)) {
                            <div
                              class="column {{ config.type }}"
                              [class.collapsed-column]="!product.platforms.product[config.columnType]"
                            >
                              <app-grouped-header-columns
                                [columns]="config.columns"
                                [widths]="config.widths"
                                [columnName]="config.columnName"
                                [isColumnOpen]="product.platforms.product[config.columnType]"
                                (openColumn)="toggleActionsColumn({
                                  monthNumber: monthData.monthNumber,
                                  productId: product.id,
                                  platformType: 'product',
                                  columnType: config.columnType
                                })"
                                (closeColumn)="toggleActionsColumn({
                                  monthNumber: monthData.monthNumber,
                                  productId: product.id,
                                  platformType: 'product',
                                  columnType: config.columnType
                                })"
                              />
                            </div>
                          }
                        }
                      </div>
                      <div class="teams">
                        @for (team of product.teams; track $index) {
                          <div class="team">
                            <div class="group-rows">
                              <app-plan-fact-reviewer-row
                                [selectedYear]="selectedYear()"
                                [monthData]="monthData"
                                [product]="product"
                                [team]="team"
                              />
                              <app-plan-fact-managers-rows
                                [managerReports]="team.managerReports"
                                [selectedYear]="selectedYear()"
                                [monthData]="monthData"
                                [product]="product"
                                [isAssignedManager]="true"
                                [team]="team"
                                (updateValue)="updateValue($event)"
                              />
                              @if (team.notAssignedManagerPlanFacts.length) {
                                <app-plan-fact-managers-rows
                                  [managerReports]="team.notAssignedManagerPlanFacts"
                                  [selectedYear]="selectedYear()"
                                  [monthData]="monthData"
                                  [product]="product"
                                  [isAssignedManager]="false"
                                  [team]="team"
                                  (updateValue)="updateValue($event)"
                                />
                              }
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                    @for (platform of platformNames; track $index) {
                      <app-plan-fact-platform
                        [product]="product"
                        [selectedYear]="selectedYear()"
                        [monthData]="monthData"
                        [platform]="platform"
                        (toggleActionsColumn)="toggleActionsColumn($event)"
                      />
                    }
                  </div>

                  @if (product.unAddedReviewerList?.length) {
                    <div class="un-added-products">
                      <button
                        class="added-leader-button"
                        (click)="toggleUnAddedReviewerList(product)"
                      >
                        Добавить руководителя
                      </button>
                      @if (product.isUnAddedReviewerListOpen) {
                        <div
                          class="un-added-products-list"
                          [forbidTrigger]="!product.isUnAddedReviewerListOpen"
                          [excludeClass]="'added-leader-button'"
                          (appClickOutside)="toggleUnAddedReviewerList(product)"
                        >
                          @for (reviewer of product.unAddedReviewerList; track $index) {
                            <button
                              class="un-added-product"
                              (click)="addReviewerToProduct(product, reviewer.id, monthData.monthNumber)"
                            >
                              {{ reviewer.name }}
                            </button>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
              }
              <div class="un-added-products">
                <button
                  class="added-product-button"
                  (click)="toggleUnAddedProductsList(monthData)"
                >
                  Добавить продукт
                </button>
                @if (monthData.isUnAddedProductsListOpen) {
                  <div
                    class="un-added-products-list"
                    [forbidTrigger]="!monthData.isUnAddedProductsListOpen"
                    [excludeClass]="'added-product-button'"
                    (appClickOutside)="toggleUnAddedProductsList(monthData)"
                  >
                    @for (product of monthData.unAddedProductsList; track $index) {
                      <button
                        class="un-added-product"
                        (click)="addProductToMonth(monthData, product.productId)"
                      >
                        {{ product.productName }}
                      </button>
                    }
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
